import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useOccurrence } from "../context/OccurrenceContext.jsx";

const Coupon = () => {
  const { shop, name } = useParams();
  const { customerEmail } = useOccurrence();
  const navigate = useNavigate();

  useEffect(() => {
    const email = customerEmail || "";
    navigate(email ? `/${shop}/resolution/${name}/${encodeURIComponent(email)}` : `/${shop}`, { replace: true });
  }, [customerEmail, name, navigate, shop]);

  return null;
};

export default Coupon;
